module.exports = __webpack_public_path__ + "img/95.10.pH.4033e13d.png";